import { Button } from 'components/ui';
import { useModal } from 'contexts/modal';
import { useInfo } from 'contexts/info';
import { FormattedMessage } from 'react-intl';
import Edit from 'components/inspection/modal/edit';

const EditButton = ({ inspection, space, refetch }) => {
  const { addModal, removeModal } = useModal();
  const setInfo = useInfo();

  return (
    <Button
      disabled={!space.adminRole}
      variant="contained"
      onClick={() => {
        addModal(
          <Edit
            inspection={inspection}
            onSuccess={() => {
              refetch();
              removeModal();
              setInfo('info.inspection.edited');
            }}
            handleClose={() => removeModal()}
          />
        );
      }}
    >
      <FormattedMessage id="button.edit" />
    </Button>
  );
};

export default EditButton;
